import React, { useContext, useEffect } from 'react';

import { DilutionScreen, MlUnits } from '../../../../types';

import CalculatorComponent from '../../../../components/CalculatorComponent';

import { DilutionAdditionVolumeContext } from '../../../../contexts/DilutionProvider/DilutionAdditionVolumeProvider';
import { CalculatorNavigationContext } from '../../../../contexts/CalculatorNavigationProvider';
import { CalculatorContext } from '../../../../contexts/CalculatorProvider';

function DilutionAdditionVolumeSecondScreen(): React.ReactElement {
 const { setBackButtonText, setNextButtonAction, setBackButtonAction } =
  useContext(CalculatorNavigationContext);

 const {
  setCurrentScreen,
  onValueChange,
  onSelectChange,
  getSelectInitialState,
  getValueInitialState,
 } = useContext(DilutionAdditionVolumeContext);

 const { setHasCheckbox, setQuestion, setUnitTypes } =
  useContext(CalculatorContext);

 const setNavigationProps = () => {
  const setBackButtonProps = () => {
   setBackButtonText('Forrige');
   setBackButtonAction(() => () => setCurrentScreen(DilutionScreen.First));
  };
  const setNextButtonProps = () => {
   setNextButtonAction(() => () => setCurrentScreen(DilutionScreen.Third));
  };
  setBackButtonProps();
  setNextButtonProps();
 };

 const setCalculatorProps = () => {
  setHasCheckbox(false);
  setQuestion('Hvor mye av det konsentrerte legemiddelet skal fortynnes?');
  setUnitTypes(MlUnits);
 };

 useEffect(() => {
  setNavigationProps();
  setCalculatorProps();
  // eslint-disable-next-line react-hooks/exhaustive-deps
 }, []);

 return (
  <CalculatorComponent
   onValueChange={onValueChange}
   onSelectChange={onSelectChange}
   valueInitialState={getValueInitialState()}
   selectInitialState={getSelectInitialState()}
  />
 );
}

export default DilutionAdditionVolumeSecondScreen;
